/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Target_PersonInputs */



/**
* | output |
* | --- |
* | "A person" |
*
* @param {Meetings_Exception_Target_PersonInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_target_person = /** @type {((inputs?: Meetings_Exception_Target_PersonInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Target_PersonInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een persoon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une personne")
	return /** @type {LocalizedString} */ ("A person")
});